import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/customer/locations/$locationId/water/')({
    component: RouteComponent,
    beforeLoad: async () => {
        // TODO: remove this when the page is no longer disabled
        throw notFound();
    },
});

function RouteComponent() {
    return <div>Hello "/_auth/locations/$locationId/water/"!</div>;
}
